<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <documents></documents>
      </b-col>
    </b-row>
    <b-card>
      <b-row>
        <b-col sm="4">
          <label><strong style="color:#990000;font-size:large">Bibliothèque Epargne / Retraite</strong></label><br><br>
          <b-form-group>
            <template slot="label"><b>Secteur :</b></template>
            <b-form-radio-group
              id="radio-group-2-3"
              v-model="secteur"
              name="radio-secteur"
              @change="onChange()"
            >
              <b-form-radio value="ess">ESS</b-form-radio>
              <b-form-radio value="interpro">INTERPRO</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col sm="4"></b-col>
        <b-col sm="4" v-if="canCreateDocument()">
          <b-button type="button" @click="editDocument()" size="md" variant="success" class="pull-right">
            <i class="fa fa-plus"></i> Ajouter un document
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col sm="6">
          <b-row v-for="(rubriques, sousCategorie) in documents" :key="'sousCategorie_L_'+sousCategorie">
            <b-col sm="12" v-if="getIndexBySousCategorie(documents, sousCategorie) < 2">
              <span><strong style="color:#729d07;font-size:large">{{ sousCategorie }}</strong></span>
              <b-card v-for="(document, rubrique) in rubriques" :key="'rubrique_'+rubrique" no-body style="margin-top:10px">
                <div class="card-smallHeader" :style="'background-color: '+extractColor(rubrique)">
                  <span style="font-size:small"><strong>{{ extractRubrique(rubrique) }}</strong></span>
                </div>
                <b-card-body class="small-padding">
                  <div v-for="doc in document" v-bind:key="doc.id">
                    <b-row>
                      <b-col sm="9">
                        <a v-if="!isEmpty(doc.chemin)" href="#" @click.prevent="downloadDocument(doc)">{{ doc.libelle }}</a>
                        <router-link v-else-if="!isEmpty(doc.url)" :to="openVideo(doc)" target="_blank">
                          <span>{{ doc.libelle }}</span>
                        </router-link>
                        <span v-else>{{ doc.libelle }}</span>
                      </b-col>
                      <b-col sm="3">
                        <span class="pull-right">
                          <i v-if="canEditDocument()" v-b-tooltip.hover title="Modifier le document" class="fa fa-edit fa-1_5x text-success clickable" @click="editDocument(doc)"></i>
                          <i v-else v-b-tooltip.hover.lefttop title="" class="fa fa-edit fa-1_5x text-secondary"></i>
                        </span>
                        <span class="pull-right mr-1"><i v-b-tooltip.hover title="Voir le document" class="fa fa-eye fa-1_5x text-primary clickable" @click="showFicheDocument(doc)"></i></span>
                        <span class="pull-right mr-1"><i style="font-size:11px">{{ getDateMaj(doc.fichier_suivis) }}</i></span>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="6">
          <b-row v-for="(rubriques, sousCategorie) in documents" :key="'sousCategorie_R_'+sousCategorie">
            <b-col sm="12" v-if="getIndexBySousCategorie(documents, sousCategorie) >= 2">
              <span><strong style="color:#729d07;font-size:large">{{ sousCategorie }}</strong></span>
              <b-card v-for="(document, rubrique) in rubriques" :key="'rubrique_'+rubrique" no-body style="margin-top:10px">
                <div class="card-smallHeader" :style="'background-color: '+extractColor(rubrique)">
                  <span style="font-size:small"><strong>{{ extractRubrique(rubrique) }}</strong></span>
                </div>
                <b-card-body class="small-padding">
                  <div v-for="doc in document" v-bind:key="doc.id">
                    <b-row>
                      <b-col sm="9">
                        <a v-if="!isEmpty(doc.chemin)" href="#" @click.prevent="downloadDocument(doc)">{{ doc.libelle }}</a>
                        <router-link v-else-if="!isEmpty(doc.url)" :to="openVideo(doc)" target="_blank">
                          <span>{{ doc.libelle }}</span>
                        </router-link>
                        <span v-else>{{ doc.libelle }}</span>
                      </b-col>
                      <b-col sm="3">
                        <span class="pull-right">
                          <i v-if="canEditDocument()" v-b-tooltip.hover title="Modifier le document" class="fa fa-edit fa-1_5x text-success clickable" @click="editDocument(doc)"></i>
                          <i v-else v-b-tooltip.hover.lefttop title="" class="fa fa-edit fa-1_5x text-secondary"></i>
                        </span>
                        <span class="pull-right mr-1"><i v-b-tooltip.hover title="Voir le document" class="fa fa-eye fa-1_5x text-primary clickable" @click="showFicheDocument(doc)"></i></span>
                        <span class="pull-right mr-1"><i style="font-size:11px">{{ getDateMaj(doc.fichier_suivis) }}</i></span>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>


<script>
import { downloadMixin } from "@/mixins/downloadMixin";
import { isEmpty } from "@/utils/fileHelper";
import Documents from "./documents/Documents"
import { espaceBibliothequeRules as rules, hasRule } from '@/utils/rulesHelper'

export default {
  name: "AccueilEpargne",
  mixins: [downloadMixin],
  components: {
    Documents
  },
  data() {
    return {
      isEmpty,
      documents: [],
      secteur: 'ess',
      rules,
      hasRule
    }
  },
  created() {
    this.getDocuments();
  },
  mounted() {
    this.$event.on('refresh-document-epargne-retraite', () => {
      this.getDocuments();
    });
  },
  methods: {
    onChange() {
      this.getDocuments();
    },
    getIndexBySousCategorie(documents, sousCategorie) {
      let keySousCategories = Object.keys(documents)
      return Object.keys(keySousCategories).find(key => keySousCategories[key] === sousCategorie);
    },
    getDocuments() {
      return new Promise((resolve, reject) => {
        this.$store.commit("IS_LOADING", true);
        let self = this;
        this.$axios
          .get('/espaceBibliotheque/documents/epargne-retraite')
          .then(response => {
            let documentsResponse = response.data.documents
            let groupedSousCategories = _.groupBy(documentsResponse, function(doc) {
              return doc.sous_categorie.libelle
            });
            _.forEach(groupedSousCategories, function (document, sousCategorie) {
              groupedSousCategories[sousCategorie] = _.filter(groupedSousCategories[sousCategorie], (doc) => doc.secteur === self.secteur);
              groupedSousCategories[sousCategorie] = _.groupBy(groupedSousCategories[sousCategorie], function(doc) {
                return doc.rubrique.libelle + doc.rubrique.couleur
              })
            })
            this.documents = groupedSousCategories
            this.$store.commit("IS_LOADING", false);
            resolve();
          })
          .catch(function(error) {
            console.log(error)
            self.$store.commit("IS_LOADING", false);
            resolve();
          });
      });
    },
    showFicheDocument(doc) {
      this.$eventBus.$emit('callShowFicheDocument', doc)
    },
    editDocument(doc) {
      this.$eventBus.$emit('callEditDocument', doc)
    },
    formatDate(textDate) {
      return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
    },
    extractColor(rubrique) {
      let words = rubrique.split('#')
      return '#'+words[1]
    },
    extractRubrique(rubrique) {
      let words = rubrique.split('#')
      return words[0]
    },
    getDateMaj(fichierSuivis) {
      let updatedAts = fichierSuivis.map(fichierSuivi => fichierSuivi.updated_at)
      let maxDate = ''
      if (updatedAts.length > 0) {
        maxDate = new Date(Math.max(...updatedAts.map(element => new Date(element))));
        maxDate = '(Màj: ' +this.formatDate(maxDate)+ ')'
      }
      return maxDate
    },
    openVideo(document) {
      return { path: '/espace-bibliotheque/document/video/' + document.url }
    },
    canEditDocument() { return hasRule(rules.CAN_EDIT_DOCUMENT); },
    canCreateDocument() { return hasRule(rules.CAN_CREATE_DOCUMENT); }
  }
}
</script>
